import script from "./AnonymousLeadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnonymousLeadModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn,QBanner,QIcon,QSlideTransition,QSpinnerDots,QLinearProgress,QAvatar,QSeparator,QSpinnerGears});
